











































































import { Component, Vue, Prop } from 'vue-property-decorator'
import * as db from '@shared/types/database'
import * as graph from '@shared/types/graphql'
import { Card, Button } from '@alpha/ink'
import ResultsSection from './ResultsSection.vue'
import Redactor from '@/components/Redactor.vue'
import EditModal from '@/components/EditModal.vue'
import ClassicTestContent from '@/components/TestDetails/ClassicTestContent.vue'
import TemplateManager, { Location } from '@/components/Templates/TemplateManager.vue'
import store from '@/store'
import { PresetTestMessages } from '@/store/modules/notification-store-module'
import analytics from '@/analytics'
import Survey from '@/components/Survey/Survey.vue'

@Component({
  components: {
    Card,
    ResultsSection,
    Survey,
    Redactor,
    Button,
    EditModal,
    ClassicTestContent,
    TemplateManager
  }
})
export default class CompletedTest extends Vue {
  @Prop() readonly assets!: Record<string, db.Asset>
  @Prop() readonly test!: db.Test
  @Prop({ required: true }) workspaceId!: string
  @Prop({ required: true }) testId!: string
  @Prop({ required: true }) location!: Location
  @Prop({ default: null }) readonly selectedTemplate!: graph.Template | null
  @Prop({ default: false }) showLivecharts!: boolean

  edit: boolean = false;
  editableAnswer: string = this.test.payload.answer?.slice() || ''
  saving: boolean = false

  async saveEdit () {
    if (this.editableAnswer === this.test.payload.answer?.slice()) {
      this.edit = false
      return
    }
    this.saving = true
    const res = await store.dispatch.workspace.updateTest({
      test: { answer: this.editableAnswer },
      workspaceId: this.workspaceId,
      testId: this.testId
    })
    analytics.track('Key Insight Edit')
    const message = res ? PresetTestMessages.keyInsightSuccess : PresetTestMessages.keyInsightFail
    store.dispatch.notification.setMessage(message)
    this.saving = false
    this.edit = false
  }

  get isLocationDefaultDraft () {
    return this.location === Location.DefaultDraftTestCreation
  }

  get payload () {
    return this.test.payload
  }

  get isTemplated () {
    return !!this.selectedTemplate && this.selectedTemplate.id !== -1
  }

  cancelEdit () {
    this.edit = false
    this.editableAnswer = this.test.payload.answer?.slice() || ''
  }
}
